import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { pdfjs } from 'react-pdf';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/css/fonts.css';
import '@/css/dashlite.min.css';
import '@/css/dashlite-theme-changes.min.css';
import 'react-toastify/dist/ReactToastify.min.css';
import '@/globals.css';
import '@/css/index.css';
import App from '@/App';
import LogRocket from 'logrocket';
import { LOGROCKET_APP_ID } from '@/constants/allconstants';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// Do not import logrocket-react: its CJS default breaks under Vite and only
// runs when VITE_LOGROCKET_APP_ID is set (stage/prod), which is why local/test pass.
if (LOGROCKET_APP_ID) {
    try {
        LogRocket.init(LOGROCKET_APP_ID, {
            network: {
                isEnabled: true,
                requestSanitizer: (request) => {
                    if (!request.url.includes('auth/login') || !request.body) {
                        return request;
                    }
                    try {
                        const body = JSON.parse(request.body);
                        return {
                            ...request,
                            body: JSON.stringify({
                                ...body,
                                password: '***************',
                            }),
                        };
                    } catch {
                        return request;
                    }
                },
            },
            console: {
                isEnabled: true,
            },
        });
    } catch (error) {
        console.warn('LogRocket init failed', error);
    }
}

const rootElement = document.getElementById('root');
if (rootElement) {
    rootElement.classList.remove('gs-html-boot');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
    <BrowserRouter>
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
        <App />
    </BrowserRouter>
);
